<template>
  <div class="odometer-container d-inline-flex align-center">
    <div 
      v-for="(char, index) in displayChars" 
      :key="index" 
      class="odometer-digit-wrapper"
      :style="isDigit(char) ? {} : { width: 'auto' }"
    >
      <div 
        v-if="isDigit(char)" 
        class="odometer-digit-column" 
        :style="{ transform: `translateY(-${Number(char) * 10}%)` }"
      >
        <span v-for="d in 10" :key="d" class="odometer-digit">{{ d - 1 }}</span>
      </div>
      <span v-else class="odometer-static-char">{{ char }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  value: number | string
}>()

const displayChars = computed(() => {
  return String(props.value).split('')
})

function isDigit(char: string) {
  return /^\d$/.test(char)
}
</script>

<style scoped>
.odometer-container {
  overflow: hidden;
  height: 1em;
  line-height: 1em;
  display: inline-flex;
}
.odometer-digit-wrapper {
  display: inline-block;
  height: 1em;
  width: 0.62em;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.odometer-digit-column {
  display: flex;
  flex-direction: column;
  transition: transform 0.7s cubic-bezier(0.34, 1.56, 0.64, 1);
  height: 10em; /* 10 digits * 1em each */
}
.odometer-digit {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1em;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
.odometer-static-char {
  display: inline-block;
  height: 1em;
  line-height: 1em;
}
</style>
